import React from "react";
import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import { connect } from "react-redux";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
} from "material-ui";
import { RouteComponentProps, withRouter } from "react-router";
import { BackButtonStyle, BackIcon } from "../../util/platformUtils";
import {
    SetShowConfirmDialog,
    getBackButtonRoute,
    getBackButtonConfirmInfo,
    showConfirmDialog,
} from "../../ducks/common";

interface IBackButtonProps extends RouteComponentProps<{}> {}

interface IBackButtonReduxProps {
    showConfirmDialog: boolean;
    confirmRequired: boolean;
    confirmMessage: string;
    route?: string;
}

interface IBackButtonDispatchProps {
    setShowConfirmDialog: (show: boolean) => void;
}

interface IBackButtonState {}

type BackButtonProps = IBackButtonProps &
    IBackButtonReduxProps &
    IBackButtonDispatchProps;

class BackButton extends React.Component<BackButtonProps, IBackButtonState> {
    constructor(props: BackButtonProps) {
        super(props);
    }

    handleBack = (skipConfirm = false) => {
        if (this.props.confirmRequired && !skipConfirm) {
            this.props.setShowConfirmDialog(true);
            return;
        }
        this.props.setShowConfirmDialog(false);

        this.goBack();
    };

    goBack = () => {
        if (this.props.route === undefined) {
            this.props.history.goBack();
        } else {
            this.props.history.replace(this.props.route);
        }
    };

    render() {
        return (
            <span>
                <Dialog
                    open={this.props.showConfirmDialog}
                    onClose={() => this.props.setShowConfirmDialog(false)}
                >
                    <DialogTitle id="responsive-dialog-title">
                        Oletko varma?
                    </DialogTitle>
                    <DialogContent>
                        <p>{this.props.confirmMessage}</p>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() =>
                                this.props.setShowConfirmDialog(false)
                            }
                        >
                            Peruuta
                        </Button>
                        <Button onClick={() => this.handleBack(true)}>
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
                <IconButton
                    aria-label="Takaisin"
                    onClick={() => this.handleBack()}
                >
                    <BackIcon style={BackButtonStyle} />
                </IconButton>
            </span>
        );
    }
}

const mapStateToProps = (state: ReduxState): IBackButtonReduxProps => {
    const defaultRoute = getBackButtonRoute(state);
    const confirmInfo = getBackButtonConfirmInfo(state);
    const showDialog = showConfirmDialog(state);

    return {
        showConfirmDialog: showDialog,
        confirmRequired: (confirmInfo && confirmInfo.required) || false,
        confirmMessage: (confirmInfo && confirmInfo.message) || "",
        route: defaultRoute,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IBackButtonDispatchProps => {
    return {
        setShowConfirmDialog: (show: boolean) => {
            dispatch(SetShowConfirmDialog(show));
        },
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(BackButton)
);



// WEBPACK FOOTER //
// ./src/components/BackButton/BackButton.tsx